export interface IChatMessageBody {
  content: string;
  userId: number;
  id: string;
  isPublic: boolean;
  isIgnored: boolean;
  isIgnoredByUser: boolean;
}

export interface IChatMessage {
  id: string;
  buyer: IChatMessageBody;
  seller: IChatMessageBody;
}

export enum ChatStatus {
  Inapplicable = 0,
  None = 1,
  NoActivity = 2,
  Activity = 3
}
